(function() {
  'use strict';

  /* jshint undef: true */
  /* global _:false */
  angular
    .module('linshare.audit')
    .constant('_', _);
})();
